// Klaviyo repeats the Shop badge's SVG definition IDs for every review.
// Namespace the definitions and their references within each badge, including
// badges inserted or updated by review pagination and filtering.
(() => {
  const namespaces = new WeakMap()
  let nextNamespace = 0

  function repairBadge(svg) {
    const definitions = svg.querySelectorAll('[id^="onsite-shop-syndication-badge-"]')
    if (!definitions.length) return

    if (!namespaces.has(svg)) namespaces.set(svg, ++nextNamespace)
    const suffix = `-floyd-review-badge-${namespaces.get(svg)}`
    const renamed = new Map()

    definitions.forEach((definition) => {
      const currentId = definition.id
      const originalId = currentId.replace(/-floyd-review-badge-\d+$/, '')
      const uniqueId = originalId + suffix
      renamed.set(currentId, uniqueId)
      renamed.set(originalId, uniqueId)
      if (currentId !== uniqueId) definition.id = uniqueId
    })

    svg.querySelectorAll('*').forEach((element) => {
      Array.from(element.attributes).forEach((attribute) => {
        let value = attribute.value
        if (attribute.name === 'aria-labelledby' || attribute.name === 'aria-describedby') {
          value = value.split(/\s+/).map((id) => renamed.get(id) || id).join(' ')
        } else if (attribute.name === 'href' || attribute.name === 'xlink:href') {
          const replacement = renamed.get(value.slice(1))
          if (value.startsWith('#') && replacement) value = '#' + replacement
        } else {
          value = value.replace(/url\(['"]?#([^)'"\s]+)['"]?\)/g, (reference, id) => {
            return renamed.has(id) ? `url(#${renamed.get(id)})` : reference
          })
        }
        if (attribute.value !== value) element.setAttribute(attribute.name, value)
      })
    })
  }

  function collectBadges(node, badges) {
    if (!(node instanceof Element)) return
    const svg = node.closest('svg')
    if (svg?.closest('.kl_reviews__review_item')) badges.add(svg)
    node.querySelectorAll('.kl_reviews__review_item svg').forEach((badge) => badges.add(badge))
  }

  const root = document.getElementById('MainContent')
  if (!root) return

  root.querySelectorAll('.kl_reviews__review_item svg').forEach(repairBadge)
  new MutationObserver((mutations) => {
    const badges = new Set()
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') collectBadges(mutation.target, badges)
      else mutation.addedNodes.forEach((node) => collectBadges(node, badges))
    })
    badges.forEach(repairBadge)
  }).observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['id', 'clip-path', 'fill', 'stroke', 'filter', 'mask', 'style', 'href', 'xlink:href', 'aria-labelledby', 'aria-describedby'],
  })
})()
